// XNGAGE CONFIDENTIAL
// __________________________
//
// Copyright (C) 2026 Xngage - All Rights Reserved
//
// All code or information contained herein is, and remains the
// property of Xngage LLC and its customers.  The intellectual
// and technical concepts contained are proprietary to Xngage LLC
// and may be covered by U.S. and Foreign Patents, patents in
// process, and are protected by trade secret or copyright law.
// Dissemination of this information or reproduction of this material
// is strictly forbidden unless prior written permission is obtained
// from Xngage LLC.
//

import { addToEndOfChain, addToStartOfChain, replaceInChain } from "@insite/client-framework/HandlerCreator";
import {
    chain,
    CreateOrRequestQuote,
    PopulateApiParameter,
} from "@insite/client-framework/Store/Pages/RfqRequestQuote/Handlers/CreateOrRequestQuote";
import { xCreateQuote, xCreateQuoteApiParameter } from "@vanmeter/App/Services/QuoteService";

// XNG-Changes: show page spinner while creating/requesting quote
export const DispatchBeginCreateOrRequestQuote: typeof PopulateApiParameter = props => {
    props.dispatch({
        type: "xRfqRequestQuote/BeginCreateOrRequestQuote",
    });
};

export const DispatchCompleteCreateOrRequestQuote: typeof PopulateApiParameter = props => {
    props.dispatch({
        type: "xRfqRequestQuote/CompleteCreateOrRequestQuote",
    });
};

export const xPopulateApiParameter: typeof PopulateApiParameter = props => {
    const quoteParameter = props.getState().pages.rfqRequestQuote.quoteParameter;
    const { quoteId, jobName, quoteType, accountId, note, poNumber } = quoteParameter as any;
    props.apiParameter = {
        quoteId,
        jobName,
        isJobQuote: quoteType === "job",
        userId: accountId,
        note,
        poNumber,
    } as xCreateQuoteApiParameter;
};

export const xCreateOrRequestQuote: typeof CreateOrRequestQuote = async props => {
    const { parameter, apiParameter } = props;
    const result = await xCreateQuote(apiParameter as xCreateQuoteApiParameter);
    if (result.successful) {
        props.apiResult = result.result;
    } else {
        parameter.onError?.(result.errorMessage);
        props.dispatch({
            type: "xRfqRequestQuote/CompleteCreateOrRequestQuote",
        });
        return false;
    }
};

addToStartOfChain(chain, DispatchBeginCreateOrRequestQuote);
addToEndOfChain(chain, DispatchCompleteCreateOrRequestQuote);
replaceInChain(chain, PopulateApiParameter, xPopulateApiParameter);
replaceInChain(chain, CreateOrRequestQuote, xCreateOrRequestQuote);
